import { FormControl, FormGroup, Validators } from '@angular/forms';
import { percentOwnerValidator } from 'src/app/validators/owner-percent-validator';

import { AddressForm } from './address-form';
import { OwnerFindingForm } from './owner-finding-form';

export class OwnerForm extends FormGroup<{
  id: FormControl<undefined | number>;
  VendorId: FormControl<undefined | number>;
  email: FormControl<undefined | string>;
  firstName: FormControl<undefined | string>;
  lastName: FormControl<undefined | string>;
  phone: FormControl<undefined | string>;
  percentOwner: FormControl<undefined | number>;
  mobile: FormControl<null | string>;
  title: FormControl<null | string>;
  dob: FormControl<undefined | Date | string>;
  ssn: FormControl<null | string>;
  tin: FormControl<null | string>;
  LexisNexisId: FormControl<null | string>;

  OwnerFinding?: FormGroup<OwnerFindingForm>;
  Address: AddressForm;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      VendorId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      email: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      firstName: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      lastName: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      phone: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      percentOwner: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        {
          nonNullable: true,
          validators: [Validators.required, percentOwnerValidator]
        }
      ),
      mobile: new FormControl<null | string>(null),
      title: new FormControl<null | string>(null),
      dob: new FormControl<undefined | Date | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      ssn: new FormControl<null | string>(null),
      tin: new FormControl<null | string>(null),
      LexisNexisId: new FormControl<null | string>(null),

      Address: new AddressForm()
    });
  }
}

/*
Vendor?: Vendor;
Contact?: Contact;
*/
